import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductDataPointParams } from "@tSurya/Services/ProductDataPointService";
import { ProductContentResults } from "@tSurya/Store/Data/ProductDataPointState";
import { Draft } from "immer";

const initialState: ProductContentResults = {
    isLoading: false,
    productContentResults: [],
    productTitle: "",
};

const reducer = {
    "Pages/ProductDetails/BeginLoadContent": (
        draft: Draft<ProductContentResults>,
        action: { params: ProductDataPointParams },
    ) => {
        draft.isLoading = true;
        draft.productTitle = action.params.productNumber;
    },
    "Pages/ProductDetails/CompleteLoadContent": (draft: Draft<ProductContentResults>, action: { result: string[] }) => {
        draft.isLoading = false;
        draft.productContentResults = action.result;
    },
    "Pages/ProductDetails/FailedLoadContent": (draft: Draft<ProductContentResults>) => {
        draft.isLoading = false;
        draft.productContentResults = [];
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
